interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "delete" (trash) asset from the Figma selection action bar. */
const FigmaDeleteTrashRedIcon = ({ width = 16, height = 16, color = '#FE552F' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9335 3.00002C13.9335 2.44773 13.5082 2.00002 12.9835 2.00002H10.5921C10.1919 0.804922 9.12067 0.004078 7.91687 1.54972e-05H6.01687C4.81307 0.004078 3.74186 0.804922 3.34167 2.00002H0.950192C0.425525 2.00002 0.000192523 2.44773 0.000192523 3.00002C0.000192523 3.5523 0.425525 4.00002 0.950192 4.00002H1.26687V12.3334C1.26687 14.3584 2.82641 16 4.75019 16H9.18351C11.1073 16 12.6669 14.3584 12.6669 12.3334V4.00002H12.9835C13.5082 4.00002 13.9335 3.5523 13.9335 3.00002ZM10.7669 12.3334C10.7669 13.2538 10.058 14 9.18354 14H4.75019C3.87575 14 3.16687 13.2538 3.16687 12.3334V4.00002H10.7669V12.3334Z'
        fill={color}
      />
      <path
        d='M5.38358 12C5.90825 12 6.33358 11.5523 6.33358 11V7.00001C6.33358 6.44772 5.90825 6.00001 5.38358 6.00001C4.85891 6.00001 4.43358 6.44772 4.43358 7.00001V11C4.43358 11.5523 4.85891 12 5.38358 12Z'
        fill={color}
      />
      <path
        d='M8.55021 12C9.07488 12 9.50021 11.5523 9.50021 11V7.00001C9.50021 6.44772 9.07488 6.00001 8.55021 6.00001C8.02555 6.00001 7.60021 6.44772 7.60021 7.00001V11C7.60021 11.5523 8.02555 12 8.55021 12Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaDeleteTrashRedIcon;
